import React from "react";
import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import Services from "./components/Services/Services";
import About from "./components/About/About";
import Calculation from "./components/Calculation/Calculation";
import Footer from "./components/Footer/Footer";

const App: React.FC = () => {
  return (
    <div className="bg-[#323738] min-h-svh text-xs overflow-x-hidden">
      <Header />
      <Hero />
      <Services />
      {/* <Clients /> */}
      <About />
      <Calculation />
      <Footer />
    </div>
  );
};

export default App;
